import { useMemo } from 'react';
import Stack from '@mui/material/Stack';
import SecurityIcon from '@mui/icons-material/Security';
import {
  groupGeneralPermissions,
  groupObjectPermissions,
} from '../../utils/permissionGrouping';
import FormSection from '../ui/FormSection';
import GeneralPermissionsPanel from './GeneralPermissionsPanel';
import ObjectPermissionsPanel from './ObjectPermissionsPanel';

export default function PermissionsEditor({
  objectPermissions = [],
  generalPermissions = [],
  disabled = false,
  onObjectChange,
  onGeneralChange,
}) {
  const objectGroups = useMemo(
    () => groupObjectPermissions(objectPermissions),
    [objectPermissions]
  );
  const generalModules = useMemo(
    () => groupGeneralPermissions(generalPermissions),
    [generalPermissions]
  );

  return (
    <FormSection
      icon={<SecurityIcon fontSize="small" />}
      title="Review permissions"
      description="Permissions are grouped by module. Expand each section to review or adjust access before creating the profile."
    >
      <Stack spacing={0}>
        <ObjectPermissionsPanel
          permissions={objectGroups}
          disabled={disabled}
          onChange={onObjectChange}
        />
        <GeneralPermissionsPanel
          modules={generalModules}
          disabled={disabled}
          onChange={onGeneralChange}
        />
      </Stack>
    </FormSection>
  );
}
